import { useTranslation } from "react-i18next";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Eye } from "@vapor/react-icons";
import { Button } from "@vapor/react-material";
import type {
    GovernmentAgencyType,
    TaxSubmissionDetailDTO,
} from "../../../../../../core/api/use-get-tax-submission-detail/TaxSubmissionDetailDTO";

export const useGetCtaPreviewOutcome = (
    onClickPreviewOutcome: (
        availableOutcomeTypes: string[],
        governmentAgencyType: GovernmentAgencyType,
        taxSubmissionId: string,
        selectedOutcomeType: string,
    ) => unknown,
    taxSubmissionDetail: TaxSubmissionDetailDTO,
) => {
    const { t } = useTranslation();

    return (
        <>
            {taxSubmissionDetail &&
                taxSubmissionDetail.outcomeTypes &&
                taxSubmissionDetail.outcomeTypes.length > 0 && (
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() =>
                            onClickPreviewOutcome(
                                taxSubmissionDetail.outcomeTypes,
                                taxSubmissionDetail.governmentAgency.type,
                                taxSubmissionDetail.id,
                                taxSubmissionDetail.outcomeTypes[0],
                            )
                        }
                    >
                        <Eye />
                        <Typography sx={{ ml: 1 }}>
                            {t(
                                "views.home.components.tax_submission_detail_toolbar.primary_cta.preview_outcome.preview_summary",
                            )}
                        </Typography>
                    </Button>
                )}
        </>
    );
};
